import BrandOrService, { IBrandOrService } from "./brandOrService";
import "./brandsAndServices.scss";
import React from "react";

export interface IBrandsAndServicesProps {
  mobile?: boolean;
  brandsAndServices: IBrandOrService[];
}

function BrandsAndServices(props: IBrandsAndServicesProps) {
  return (
    <div className={`brands-and-services ${props.mobile ? "mobile" : "desktop"}`}>
      {props.brandsAndServices &&
        props.brandsAndServices.map((brandOrService, index) => (
          <BrandOrService
            brandOrService={brandOrService}
            mobile={props.mobile}
            key={index}
          />
        ))}
    </div>
  );
}

export default BrandsAndServices;
